export const theme = {
  type : 'dark',
  color: '#fff',
  colorReverse: 'rgb(0,50,0)'
}

export const hash = 'd2f761e1-e7e5-4e72-8692-b432108c6d21';
export const gateKey = 'ek_live_HA4CIVSdx7R66y62rDr4bka7ZB2Was';
// export const gateKey = '';
export const recaptchaKey = '6LdKIrgZAAAAAFCgNLBhpQNO_a29D30zbLGQx9mb';
export const apiUrl = `https://api-global.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://global-socket.encontrodigital.com.br/';
// export const apiSocket = 'http://localhost:8001';
//export const apiUrl = `http://localhost:8000/${hash}`;
export const urlWebsite = 'https://congresso-gaucho-pneumo.encontrodigital.com.br';
export const supportNumber = `5551981476007`;
export const home = 'Home';
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'X Congresso Gaúcho de Pneumologia';
export const logo = '/assets/evento/logo.png';
export const background = '/assets/evento/fundo.png';
export const authTitle = 'X Congresso Gaúcho de Pneumologia';
export const social = {
  whatsapp: '',
  instagram: '',
  facebook: '',
  linkedin: '',
  youtube: '',
  twitter: '',
};

export const dadosOrganizacao = '';

export const defaultTheme = {
  lightColor: '#fff',
  darkColor: '#fff',
  defaultBackground: '#fff',
  defaultColor: '#000',
  logo: {
    minWidth: '75px',
  },
  menu: {
    background: '#fff',
    backgroundSticky: '#fff',
    backgroundMobile: '#fff',
    mobileColor: 'rgb(0,100,00)',
    color: 'rgb(0,100,00)',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
